import api from 'api';

export const loadUsers = api('GET /api/influencers-campaigns/fields/users');

export const loadActiveUsers = api(
  'GET /api/influencers-campaigns/fields/users/active'
);

export const loadMasterCampaigns = api(
  'GET /api/influencers-campaigns/fields/master-campaigns'
);

export const loadMasterCampaign = api(
  'GET /api/influencers-campaigns/fields/master-campaign/:id'
);

export const loadCostModels = api(
  'GET /api/influencers-campaigns/fields/cost-models'
);

export const loadPlatforms = api(
  'GET /api/influencers-campaigns/fields/platforms'
);

export const loadBriefs = api('GET /api/influencers-campaigns/fields/briefs');

export const loadCountries = api(
  'GET /api/influencers-campaigns/fields/countries'
);

export const loadPromoCodes = api(
  'GET /api/influencers-campaigns/fields/promo-codes'
);

export const loadCurrencies = api(
  'GET /api/influencers-campaigns/fields/currencies'
);
export const loadSubTypes = api(
  'GET /api/influencers-campaigns/fields/sub-types'
);

export const loadRewardPackages = api(
  'GET /api/influencers-campaigns/fields/reward-packages'
);

export const loadAdditionalRewardConditions = api(
  'GET /api/influencers-campaigns/fields/reward-packages/conditions'
);

export const loadLandingPages = api(
  'GET /api/influencers-campaigns/fields/conversion-pages'
);

export const loadIOSLandingPages = api(
  'GET /api/influencers-campaigns/fields/conversion-pages/ios'
);

export const loadAndroidLandingPages = api(
  'GET /api/influencers-campaigns/fields/conversion-pages/android'
);

export const loadAgencies = api(
  'GET /api/influencers-campaigns/fields/agencies'
);

export const loadInfuencersChannels = api(
  'GET /api/influencers-campaigns/fields/influencers-channels'
);

export const loadPriceWithFee = api(
  'GET /api/influencers-campaigns/fields/price-with-fee'
);

export const loadLocations = api(
  'GET /api/influencers-campaigns/fields/locations'
);

export const loadGGLinks = api('POST /api/influencers-campaigns/gg-links');
